import useSearchSelect from 'features/legacy/hooks/search/useSearchSelect';

const useSectorsSearchSelect = sectors => useSearchSelect(sectors);

export default useSectorsSearchSelect;
